import LinkedJackpots from './LinkedJackpots';

export default LinkedJackpots;
